module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_under_30.522820b8.webp";